<!-- 合同签署弹窗 -->
<style lang="scss" scoped>
.protocol-content {
  background: #ffffff;
  padding: 20px;
}
.footer {
  text-align: center;
  margin-top: 24px;
}
</style>

<style lang="scss">
.protocol-dialog-wrapper {
  padding: 0 !important;

  .el-dialog__header {
    padding: 16px;
    .el-dialog__title {
      font-size: 18px;
      font-weight: 500;
    }
  }

  .el-dialog__body {
    background: #f2f2f2;
    padding: 20px;
  }

  .el-dialog__headerbtn {
    font-size: 18px;
    height: 58px;
  }
}
</style>

<template>
  <el-dialog
    v-model="visible"
    class="protocol-dialog-wrapper"
    title="合同签署"
    width="976px"
    append-to-body
    :close-on-click-modal="false"
    @before-close="close"
  >
    <div class="protocol-content">
      <iframe
        :src="`${protocolUrl}#view=FitH&scrollbar=0&toolbar=0&statusbar=0`"
        scrollbar="0"
        frameborder="0"
        style="width: 100%; height: 600px"
        allowfullscreen
      ></iframe>
      <div class="footer">
        <el-button
          v-loading="loading"
          element-loading-custom-class="small-loading"
          element-loading-background="rgba(255, 255, 255, 0.5)"
          type="primary"
          size="large"
          :disabled="countdown > 0"
          @click="signAgreement"
          >立即签署<span v-if="countdown > 0">({{ countdown }}s)</span></el-button
        >
      </div>
    </div>
  </el-dialog>
</template>

<script setup>
import { ref } from 'vue'
import userApi from '@/apis/user'

const emit = defineEmits(['signSuccess'])

const visible = ref(false)
const corpId = ref('')
const protocolUrl = ref('')
const countdown = ref(5)
const timer = ref(null)
const loading = ref(false)
const open = (params) => {
  protocolUrl.value = params.url
  corpId.value = params.corpId
  visible.value = true
  startCountdown()
}

const startCountdown = () => {
  countdown.value = 5

  // 每秒更新倒计时
  timer.value = setInterval(() => {
    countdown.value--
    if (countdown.value <= 0) {
      clearInterval(timer.value)
      timer.value = null
    }
  }, 1000)
}

const close = () => {
  visible.value = false
  if (timer.value) {
    clearInterval(timer.value)
    timer.value = null
  }
}

const signAgreement = async () => {
  try {
    loading.value = true
    await userApi.postSignAgreement({ corpId: corpId.value })
    ElMessage.success('发起成功')
    emit('signSuccess')
    close()
  } catch (error) {
    console.log(error)
  } finally {
    loading.value = false
  }
}

defineExpose({
  open,
  close,
})
</script>
